module.exports = {
    header: {
        home: 'HOME',
        members: 'MEMBERS',
        faculty: 'FACULTY',
        students: 'STUDENTS',
        alumni: 'ALUMNI',
        project: 'PROJECTS',
        publication: 'PUBLICATIONS',
        photo: 'PHOTOS',
        studentMap: 'STUDENT ON MAP',
        acemap: 'Acemap',
        iiot: 'IOT',
        dde: 'DDE',
        geoscience: 'Geo Science',
        ai: 'AI',
        socialscience: 'Social Science',
        security: 'Security',
        lang: '中文版',
        subTitle: 'Data Intelligence Research Center',
        academic: 'Academic Life',
        life: 'Students Life',
        spiritual: 'Spiritual Outlook',
        courses: 'COURSE',
        course: 'Course',
        material: 'Materials',
        afterSchool: 'After Class',
        talk: 'DIRC TALK'

    },
    member: {
        committee: 'Steering Committee Members',
        leading: 'Leading Members',
        professor: 'Guest Professors',
        alumni: 'Alumni',
        scholar: 'Scholars',
        entrepreneur: 'Entrepreneurs',
    },
    project: {

    },
    publication: {

    }
}